/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminProductStatus,
    AdminProductStatusFromJSON,
    AdminProductStatusFromJSONTyped,
    AdminProductStatusToJSON,
} from './AdminProductStatus';
import {
    AdminUpdateProductMarketplace,
    AdminUpdateProductMarketplaceFromJSON,
    AdminUpdateProductMarketplaceFromJSONTyped,
    AdminUpdateProductMarketplaceToJSON,
} from './AdminUpdateProductMarketplace';
import {
    ProductConsistency,
    ProductConsistencyFromJSON,
    ProductConsistencyFromJSONTyped,
    ProductConsistencyToJSON,
} from './ProductConsistency';

/**
 * 
 * @export
 * @interface AdminUpdateProduct
 */
export interface AdminUpdateProduct {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProduct
     */
    asin?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProduct
     */
    categoryID: number;
    /**
     * 
     * @type {ProductConsistency}
     * @memberof AdminUpdateProduct
     */
    consistency: ProductConsistency;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateProduct
     */
    consistencyDetails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProduct
     */
    description: string;
    /**
     * LoadedStatus is the status the form was loaded with: when it changed
     * meanwhile (e.g. an eBay sale), an untouched Status does not overwrite it.
     * @type {AdminProductStatus}
     * @memberof AdminUpdateProduct
     */
    loadedStatus?: AdminProductStatus;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProduct
     */
    lowestResalePrice: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProduct
     */
    mSRP: number;
    /**
     * Marketplaces: rows of eBay listings published from the admin are kept
     * as they are in the database, whatever the request holds for them.
     * @type {Array<AdminUpdateProductMarketplace>}
     * @memberof AdminUpdateProduct
     */
    marketplaces?: Array<AdminUpdateProductMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProduct
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProduct
     */
    palletOrderID?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProduct
     */
    purchasePrice: number;
    /**
     * 
     * @type {AdminProductStatus}
     * @memberof AdminUpdateProduct
     */
    status: AdminProductStatus;
}



export function AdminUpdateProductFromJSON(json: any): AdminUpdateProduct {
    return AdminUpdateProductFromJSONTyped(json, false);
}

export function AdminUpdateProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': !exists(json, 'asin') ? undefined : json['asin'],
        'categoryID': json['categoryID'],
        'consistency': ProductConsistencyFromJSON(json['consistency']),
        'consistencyDetails': !exists(json, 'consistencyDetails') ? undefined : json['consistencyDetails'],
        'description': json['description'],
        'loadedStatus': !exists(json, 'loadedStatus') ? undefined : AdminProductStatusFromJSON(json['loadedStatus']),
        'lowestResalePrice': json['lowestResalePrice'],
        'mSRP': json['mSRP'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminUpdateProductMarketplaceFromJSON)),
        'name': json['name'],
        'palletOrderID': !exists(json, 'palletOrderID') ? undefined : json['palletOrderID'],
        'purchasePrice': json['purchasePrice'],
        'status': AdminProductStatusFromJSON(json['status']),
    };
}

export function AdminUpdateProductToJSON(value?: AdminUpdateProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'categoryID': value.categoryID,
        'consistency': ProductConsistencyToJSON(value.consistency),
        'consistencyDetails': value.consistencyDetails,
        'description': value.description,
        'loadedStatus': AdminProductStatusToJSON(value.loadedStatus),
        'lowestResalePrice': value.lowestResalePrice,
        'mSRP': value.mSRP,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminUpdateProductMarketplaceToJSON)),
        'name': value.name,
        'palletOrderID': value.palletOrderID,
        'purchasePrice': value.purchasePrice,
        'status': AdminProductStatusToJSON(value.status),
    };
}

